import { i18n } from "../i18n";
import NumberUtils from "../input/NumberUtils";

export const AbcNumericFilter = (num: number, decimals = -1, locale = i18n.locale) => {
    return NumberUtils.stringify(num, decimals, true, locale) 
}
